<div class="d-flex flex-column">
  <div class="d-flex">
    <div class="align-self-start"><i class="fa fa-th-large red mr-1"></i></div>
    <div [innerHTML]="'phonenumber_block_type' | i18next: { length: length }"></div>
  </div>
  <div class="row">
    <div class="col-auto p-0 m-0" style="min-width: 130px;">
      <div class="text-nowrap">{{ 'start' | i18next }}:</div>
    </div>
    <div class="col-auto p-0 m-0">
      <div>{{from | phonenumber }}</div>
    </div>
  </div>
  <div class="row">
    <div class="col-auto p-0 m-0" style="min-width: 130px;">
      <div class="text-nowrap">{{ 'end' | i18next }}:</div>
    </div>
    <div class="col-auto p-0 m-0">
      <div>{{ to | phonenumber }}</div>
    </div>
  </div>
  @if (deliveryDate) {
    <div class="row">
      <div class="col-auto p-0 m-0" style="min-width: 130px;">
        <div class="text-nowrap">{{ 'phonenumber_delivery_date' | i18next }}:</div>
      </div>
      <div class="col-auto p-0 m-0">
        <div>{{ deliveryDate | localized_date }}</div>
      </div>
    </div>
  }
</div>